export default "__VITE_ASSET__CazNCwWE__"